import { defineMessages } from 'react-intl';

const messages = defineMessages({
  finishTitle: {
    id: 'registration.consent.title',
    defaultMessage: 'Create account',
    description: 'Registration consent finish title',
  },
  byRegistering: {
    id: 'registration.consent.byRegistering',
    defaultMessage:
      'By registering you agree that AGCO will process your data as outlined in the <privacy>AGCO Privacy Statement</privacy>',
    description: 'Registration consent finish - by registering',
  },
  marketing: {
    id: 'registration.consent.marketing',
    defaultMessage: 'Marketing Preferences',
    description: 'Registration consent finish - marketing',
  },
  marketingDescription: {
    id: 'registration.consent.marketingDescription',
    defaultMessage:
      'To benefit from all features of the portal, we need your consent to provide you with a personalized experience. This declaration is voluntary and can be withdrawn at any time',
    description: 'Registration consent finish - marketing description',
  },
  whatDoesThisMean: {
    id: 'registration.consent.whatDoesThisMean',
    defaultMessage: 'What does this mean?',
    description: 'Registration consent finish - what does this mean',
  },
  marketingDescription2: {
    id: 'registration.consent.marketingDescription2',
    defaultMessage:
      'By personal data we mean information about yourself (i.e. name, email address, postal address, telephone number, business contact details, profession and similar Information relating to you), demographic information (i.e., age, gender, location) and data relating to your business enterprise. This data may be transmitted to AGCO Corporation and its subsidiaries (together, “AGCO”) for marketing, market research and advertising purposes and collected, processed and used for these purposes. You may therefore receive information about products and services offered by AGCO.',
    description: 'Registration consent finish - marketing description 2',
  },
  marketingConsent: {
    id: 'registration.consent.marketingConsent',
    defaultMessage:
      'I consent that my data can be used by AGCO Corporation and its subsidiaries (together, “AGCO”) for marketing, market research and advertising purposes and collected, processed and used for these purposes.',
    description: 'Registration consent finish - marketing consent',
  },
  marketingConsentPostal: {
    id: 'registration.consent.marketingConsentPostal',
    defaultMessage: 'Via postal service',
    description: 'Registration consent finish - marketing consent postal',
  },
  marketingConsentEmail: {
    id: 'registration.consent.marketingConsentEmail',
    defaultMessage: 'Via email',
    description: 'Registration consent finish - marketing consent email',
  },
  marketingConsentPhone: {
    id: 'registration.consent.marketingConsentPhone',
    defaultMessage: 'Via phone',
    description: 'Registration consent finish - marketing consent phone',
  },
  marketingConsentSMS: {
    id: 'registration.consent.marketingConsentSMS',
    defaultMessage: 'Via SMS/Messaging services',
    description: 'Registration consent finish - marketing consent SMS',
  },
  yourRights: {
    id: 'registration.consent.yourRights',
    defaultMessage: 'Your Rights',
    description: 'Registration consent finish - your rights',
  },
  yourRightsDescription: {
    id: 'registration.consent.yourRightsDescription',
    defaultMessage:
      'You can fully or partially revoke your consent at any time without indicating the reason to AGCO. You may exercise your rights of access, rectification, erasure and objection by writing to AGCO at AGCO International GmbH, Data Privacy, Victor von Bruns-Strasse 17, 8212 Neuhasen am Rheinfall, Switzerland or simply by sending an email to: {email}',
    description: 'Registration consent finish - your rights description',
  },
  createAgcoAccount: {
    id: 'registration.consent.createAccount',
    defaultMessage: 'Create my AGCO account',
    description: 'Registration consent finish - create account',
  },
  pleaseSelectMarketingChannels: {
    id: 'registration.consent.pleaseSelectMarketingChannels',
    defaultMessage: 'Please select at least one marketing channel to proceed',
    description: 'Registration consent finish - please select marketing channels',
  },
});

export default messages;
